<div class="card-header">
    <h5> {{comparisonResults}} </h5><br>
</div>
<div class="col-sm-12">
    <div class="form-group row">
        <div class="col-xl-3 col-md-3">
            <label for="searchBox" style="word-wrap:break-word">
                {{searchLabelText}}
            </label>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-xl-3 col-md-3 mt-1">
            <input class="form-control" id="searchBox" [(ngModel)]="searchText" type="text"
                placeholder="{{searchLabelText}}">
        </div>
        <div class="col-xl-auto col-md-auto mt-1">
            <button type="button" class="btn btn-primary" (click)="onSearch()">{{search}}
            </button>
        </div>
    </div>
</div>
<ng-container *ngIf="!isMobileList">
    <div class="table-wrapper">
        <table class="table-responsive" border=1 frame=void rules=rows>
            <thead>
                <tr>
                    <th scope="col">{{noCrt}}</th>
                    <th scope="col">{{supplier}}</th>
                    <th scope="col">{{offerName}}</th>
                    <th scope="col">{{offerType}}</th>
                    <th scope="col">{{details}}</th>
                    <th scope="col">{{renewableEnergy}}</th>
                    <th scope="col">{{invoiceValue}}</th>
                    <th scope="col">{{invoiceUnitValue}} </th>
                    <th scope="col">{{invoiceValueComparison}} </th>
                    <th scope="col">{{economyCost}} </th>
                    <th scope="col">{{comparisonResult}}</th>
                    <th scope="col">{{suppliersComparison}} </th>
                    <th scope="col">{{contractingInformation}} </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th></th>
                    <th>
                        <i class="fa fa-sort-down fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'supplier'&& this.sortDirection =='down'}"
                            (click)="onSort(supplier,'down')"></i>
                        <i class="fa fa-sort-up fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'supplier'&& this.sortDirection =='up'}"
                            (click)="onSort(supplier,'up')"></i>
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>
                        <i class="fa fa-sort-down fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'invoiceValue'&& this.sortDirection =='down'}"
                            (click)="onSort(invoiceValue,'down')"></i>
                        <i class="fa fa-sort-up fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'invoiceValue'&& this.sortDirection =='up'}"
                            (click)="onSort(invoiceValue,'up')"></i>
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>

                </tr>
                <ng-container *ngFor="let electricComparatorResult of electricComparatorResults;let i = index">
                    <tr>
                        <th scope="row">{{i+1}}</th>
                        <td><a href="{{electricComparatorResult.legatura_oferta}}"
                                target="_blank">{{electricComparatorResult.nume_furnizor}}</a>
                        </td>
                        <td><a href="{{electricComparatorResult.oferta_pdf}}"
                                target="_blank">{{electricComparatorResult.denumire_oferta}}</a>
                        </td>
                        <td [ngClass]="onDisplayOfferType(electricComparatorResult.tip_oferta)">
                            {{electricComparatorResult.tip_oferta}}</td>
                        <td (click)="onExpandDetails(electricComparatorResult)"><a href="javascript:void(0);"
                                *ngIf="electricComparatorResult.isSubRowDisplayed">{{closeDetails}}</a>
                            <a href="javascript:void(0);"
                                *ngIf="!electricComparatorResult.isSubRowDisplayed">{{viewDetails}}</a>
                        </td>
                        <td>
                            <ng-container *ngIf="electricComparatorResult.procent_energie_surse_regenerabile > 0">
                                <img src="../../../../assets/images/leaf.png" width="32"><br />
                            </ng-container>
                            {{electricComparatorResult.procent_energie_surse_regenerabile}}%
                        </td>
                        <td class="bold">{{electricComparatorResult.valoare_factura_furnizor_fc}}</td>
                        <td>{{electricComparatorResult.pret_final}}</td>
                        <td><span class="red"
                                *ngIf="!comparatorForm.controls.currentInvoiceValue.value">{{fillInTheCurrentInvoiceValue}}</span>
                            <span
                                [ngClass]="{'green': onConvertToNumber(electricComparatorResult.rezultat_comparatie_valoare_factura) <= 0,
                                'red': onConvertToNumber(electricComparatorResult.rezultat_comparatie_valoare_factura) > 0}"
                                *ngIf="comparatorForm.controls.currentInvoiceValue.value">
                                <span
                                    *ngIf="onConvertToNumber(electricComparatorResult.rezultat_comparatie_valoare_factura) <= 0">
                                    ⇓
                                </span>
                                <span
                                    *ngIf="onConvertToNumber(electricComparatorResult.rezultat_comparatie_valoare_factura) > 0">
                                    ⇑
                                </span>
                                {{electricComparatorResult.rezultat_comparatie_valoare_factura}} %</span>
                        </td>
                        <td>
                            <span class=" red"
                                *ngIf="!comparatorForm.controls.currentInvoiceValue.value">{{fillInTheCurrentInvoiceValue}}</span>
                            <span [ngClass]="{'green': onConvertToNumber(electricComparatorResult.rezultat_economie_cost) < 0,
                                'red': onConvertToNumber(electricComparatorResult.rezultat_economie_cost) >= 0}"
                                *ngIf="comparatorForm.controls.currentInvoiceValue.value">
                                <span *ngIf="onConvertToNumber(electricComparatorResult.rezultat_economie_cost) <= 0"> ⇓
                                </span>
                                <span *ngIf="onConvertToNumber(electricComparatorResult.rezultat_economie_cost) > 0"> ⇑
                                </span>
                                {{electricComparatorResult.rezultat_economie_cost}}</span>
                        </td>
                        <td>
                            <ng-container *ngIf="invoiceValueComparisonResult[i]">
                                <span [ngClass]="{'green': this.invoiceValueComparisonResult[i] > 0,
                                    'red': this.invoiceValueComparisonResult[i] <= 0}">
                                    <span *ngIf="invoiceValueComparisonResult[i] > 0"> ⇓
                                    </span>
                                    <span *ngIf="invoiceValueComparisonResult[i] < 0"> ⇑
                                    </span>
                                    {{invoiceValueComparisonResult[i]}}
                                    <ng-container *ngIf="+invoiceValueComparisonResult[i]"> %
                                    </ng-container>
                                </span>
                            </ng-container>
                        </td>
                        <td>
                            <select class="form-control" [(ngModel)]="selectedComparisonValues[i]"
                                (change)="onComputeInvoiceValueComparisonResult(selectedComparisonValues[i], electricComparatorResult.valoare_factura_furnizor_fc, i)">
                                <option [ngValue]="null" selected>Selecteaza furnizorul</option>
                                <option *ngFor="let comparisonSupplier of comparisonSuppliers"
                                    [ngValue]="comparisonSupplier.value">{{comparisonSupplier.name}}</option>
                            </select>
                        </td>
                        <td>
                            <a href="javascript:void(0);"
                                (click)="openDocumentsModal(electricComparatorResult)">{{open}}</a>
                        </td>
                        <td class="bold" *ngIf="isSelectOfferButtonVisible">
                          <a style="cursor:pointer;" class="link" (click)="checkAndSaveOfferToStorage(electricComparatorResult)">{{selectOffer}}</a>
                        </td>
                    </tr>
                    <tr>
                        <td *ngIf="electricComparatorResult.isSubRowDisplayed" colspan="15">
                            <app-comparator-energy-result [electricComparatorResult]="electricComparatorResult">
                            </app-comparator-energy-result>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</ng-container>
<ng-container *ngIf="isMobileList">
  <ng-container *ngFor="let electricComparatorResult of electricComparatorResults;let i = index">
    <app-comparator-energy-result [comparatorForm]="comparatorForm" [isMobileView]="true"
                                  [electricComparatorResult]="electricComparatorResult"
                                  [isSelectOfferButtonVisible]="isSelectOfferButtonVisible"
                                  (selectOffer)="checkAndSaveOfferToStorage(electricComparatorResult)">
    </app-comparator-energy-result>
  </ng-container>
</ng-container>
<p class="energyNote">{{energyTableNotification}}</p>
